import { render, staticRenderFns } from "./PayPalPayout.vue?vue&type=template&id=b3f3148c&"
import script from "./PayPalPayout.vue?vue&type=script&lang=ts&"
export * from "./PayPalPayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports